import { render, staticRenderFns } from "./TZ.vue?vue&type=template&id=65413b8d"
import script from "./TZ.vue?vue&type=script&lang=js"
export * from "./TZ.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports